import {getColumnSearchProps} from "./TableColumnSearch"

export default getColumnSearchProps
